<span [innerHTML]="staticTemplate"></span>